import {Grid, GridProps} from "@mantine/core";
import {useMemo} from "react";
import {dvirsSelector, useGetLatestVehicleDVIRsQuery, VehicleEntity} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {DVIRDataTable} from "../../data-table/DVIRDataTable/DVIRDataTable";
import {useApp} from "../../../providers/RegionProvider/RegionProvider";

export type VehicleDVIRViewProps = Omit<GridProps, 'children'> & {
  vehicle: VehicleEntity
}

export const VehicleDVIRView = (props: VehicleDVIRViewProps) => {
  const {
    vehicle,
    ...rest
  } = props

  const {regionId} = useApp()

  const selectDVIRs = useMemo(() => {
    return dvirsSelector();
  }, []);

  const arg = useMemo(() => {
    if (regionId) {
      return {
        regionId: regionId,
        vehicleId: vehicle.id,
      }
    } else {
      return skipToken
    }
  }, [regionId, vehicle.id])

  const {dvirs, isLoading, isFetching} = useGetLatestVehicleDVIRsQuery(arg, {
    selectFromResult: (result) => ({
      dvirs: selectDVIRs(result),
      isLoading: result.isLoading,
      isFetching: result.isFetching,
    })
  });

  return (
    <Grid {...rest}>
      <Grid.Col span={12}>
        <DVIRDataTable
          withBorder
          records={dvirs}
          recordsPerPageOptions={[10, 25, 50, 75, 100]}
          fetching={isLoading || isFetching}
        />
      </Grid.Col>
    </Grid>
  )
}
